import { render, staticRenderFns } from "./NormalForm.vue?vue&type=template&id=83cf7b04"
import script from "./NormalForm.vue?vue&type=script&lang=js"
export * from "./NormalForm.vue?vue&type=script&lang=js"
import style0 from "./NormalForm.vue?vue&type=style&index=0&id=83cf7b04&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports